import SvgIcon from '../svg/SvgIcon'

export default props => {
  const { enabled, active, onClick, scale = 1, svgIcons } = props
  const enabledClass = enabled ? '' : 'disabled'
  const selected = active ? 'selected' : ''

  const buttonProps = {
    className: `quickspin ${enabledClass}`
  }

  let style = {}
  if (window.innerWidth < 900 && window.innerWidth > window.innerHeight) {
    style = { transform: `scale(${scale})` }
  }

  return (
    <div {...buttonProps} style={{ ...style }}>
      < SvgIcon
        svgIcons={svgIcons}
        iconName={`quickspin${selected ? '-selected' : ''}`}
        hasClickIcon={true}
        onClick={onClick}
      />
    </div>
  )
}
